const SR = (state = [], action) => {

	let SR;

	switch (action.type) {

		case 'PUT_SR':
			SR = action.payload.sr;

			return { ...SR };

		case 'CLEAR_SR':

			SR = {};

			return { ...SR };

		default:

			return state;
	}
}

export default SR;



// WEBPACK FOOTER //
// ./src/reducers/sr.js